var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star_purple500",
    clipPath: "url(#clip0_1634_272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.1459 23.1726L24.4077 28.1591L22.2153 18.761L29.5145 12.4376L19.9025 11.6222L16.1459 2.75879L12.3894 11.6222L2.77734 12.4376L10.0766 18.761L7.88414 28.1591L16.1459 23.1726Z",
    fill: "#F8A401"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1634_272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.0846,
    height: 32.0846,
    fill: "white",
    transform: "translate(0.103516 0.0849609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFull);
export default __webpack_public_path__ + "static/media/star_full.5451ef35855107db767c9a8c39d29202.svg";
export { ForwardRef as ReactComponent };